import React from "react";
import "../App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { RxArrowLeft, RxArrowRight } from "react-icons/rx";

import AdityaBirla from "../assets/clients-img/grasim.jpeg";
import paratex from "../assets/clients-img/paratex.jpg";
import bhilosa from "../assets/clients-img/i-12.jpeg";
import aarti from "../assets/clients-img/i-1.jpeg";
import igl from "../assets/clients-img/i-6.jpg";
import afrisisn from "../assets/clients-img/afrisian01.jpg";
import mfl from "../assets/clients-img/mfl.jpeg";
import technoliogy from "../assets/clients-img/afrisian02.jpg";

const data = [
  {
    image: AdityaBirla,
    description:
      "Grasim Industries Limited is a flagship company of the Aditya Birla Group, a conglomerate based in India. The company is involved in various business sectors, including viscose staple fiber (VSF), cement, chemicals, and textiles.",
    company: "- Grasim Industries Limited Rajahmundary",
  },
  {
    image: paratex,
    description:
      "Pratex Inc. is a dynamic and innovative company specializing in the development and manufacturing of advanced technological solutions across various industries.",
    company: "- Paratex Inc",
  },
  {
    image: bhilosa,
    description:
      "Bhilosa Industries Pvt Ltd is a prominent player in the Indian textile industry, renowned for its innovative approach and commitment to quality.",
    company: "- Bhilosa Industries Pvt Ltd.",
  },
  {
    image: aarti,
    description:
      "Aarti Industries Limited is a leading Indian company engaged in the production of specialty chemicals and pharmaceuticals.",
    company: "- Aarti Industries Limited",
  },
  {
    image: igl,
    description:
      "Indian Glycols Limited (IGL) is a leading manufacturer of green technology-based chemicals and a pioneer in the Indian chemical industry.",
    company: "- Indian Glycols Limited (IGL) Kashipur, Uttarakhand",
  },
  {
    image: afrisisn,
    description:
      "The Afrisian is more than a name-it's a vision of unity, mutual respect, and shared creativity rooted in vibrant traditions of Africa and Asia.",
    company: "- Afrisian Industries Limited",
  },
  {
    image: mfl,
    description:
      "The MFL Epigral project in Gujarat is a cutting-edge pharmaceutical initiative dedicated to the development and manufacture of high-quality, affordable medications.",
    company: "- MFL EPIGRAL Industries Limited.",
  },
  {
    image: technoliogy,
    description:
      "TECHNOILOGY is owned by the BERNARDINI family active in the Fats & Oils industry since 1950, recognized globally for its innovation in this sector.",
    company: "- TECHNOILOGY",
  },
];

const ClientCarousel = () => {
  const sliderRef = React.useRef(null);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div className="bg-gray-100 py-12">
      {/* Header Section */}
      <div className="text-center mb-10">
        <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-2">
          Our Clientele
        </h1>
        <p className="font-bold text-lg md:text-xl text-blue-800">
          We provide high-standard solutions for your business needs.
        </p>
      </div>

      {/* Carousel Section */}
      <div className="relative w-[90%] lg:w-[80%] mx-auto">
        {/* Left Navigation Button */}
        <button
          onClick={() => sliderRef.current.slickPrev()}
          className="absolute top-1/2 -left-6 transform -translate-y-1/2 bg-purple-600 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-500 transition z-10"
        >
          <RxArrowLeft size={20} />
        </button>

        {/* Right Navigation Button */}
        <button
          onClick={() => sliderRef.current.slickNext()}
          className="absolute top-1/2 -right-6 transform -translate-y-1/2 bg-purple-600 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-500 transition z-10"
        >
          <RxArrowRight size={20} />
        </button>

        <Slider ref={sliderRef} {...settings}>
          {data.map((item, index) => (
            <div key={index} className="p-4">
              {/* Card Container */}
              <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                {/* Image */}
                <img
                  src={item.image}
                  alt={item.company}
                  className="w-full h-48 object-contain p-4"
                />
                {/* Description */}
                <div className="p-4 bg-purple-800">
                  <p className="text-white text-center font-medium">
                    {item.description}
                  </p>
                </div>
                {/* Company Name */}
                <div className="p-2 bg-purple-700">
                  <p className="text-slate-100 text-center font-semibold">
                    {item.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ClientCarousel;
